import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-colorPicker',
  templateUrl: './colorPicker.component.html',
  styleUrls: ['./colorPicker.component.css']
})
export class ColorPickerComponent implements OnInit {

  @Output() onSelectClr = new EventEmitter<string>();
  public colorsList1: any;
  public colorsList2: any;
  public selectedColor: string;
  public selClrInd: any;


  isActiveIndex = 0;

  constructor() {

  }

  ngOnInit() {

    this.colorsList1 = ['#FF9800', '#6566df', '#CDDC39', '#ffff00', '#795548', '#F44336', '#009688', '#ffffff', '#babbbc', '#000000'];
    this.colorsList2 = ['#F44336', '#009688', '#ffffff', '#babbbc', '#000000'];

    this.isActiveIndex = 0;
  }

  clickClrPickerBox(clr, index) {
    this.selectedColor = clr;
    this.selClrInd = index;
    //layer.changeColor(clr);
    this.onSelectClr.emit(this.selectedColor);


  }
  isActive(val) {
    this.isActiveIndex = val;
  }


  changeSliderClr(val) {
    this.selectedColor = val.color.hex;
    this.onSelectClr.emit(this.selectedColor);
  }


}



// WEBPACK FOOTER //
// ./src/app/bookShared/popups/colorPicker/colorPicker.component.ts